import { createFileRoute, Outlet, redirect, Link } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { BottomNav } from "@/components/BottomNav";
import { useAppSettings } from "@/lib/settings";
import { useIsAdmin } from "@/lib/auth";
import { Wrench } from "lucide-react";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    // Fast path: getSession() reads the JWT from local storage synchronously
    // (no network) so cold start is not blocked by an auth-server round-trip.
    const { data } = await supabase.auth.getSession();
    if (!data.session) throw redirect({ to: "/auth" });
    return { user: data.session.user };
  },
  component: AuthLayout,
});

function AuthLayout() {
  const { data: settings } = useAppSettings();
  const { data: isAdmin } = useIsAdmin();
  const maintenance = !!settings?.system?.maintenance;

  if (maintenance && !isAdmin) {
    return (
      <div className="mobile-shell flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-8 text-center">
        <div className="grid h-16 w-16 place-items-center rounded-full bg-primary/10 text-primary">
          <Wrench className="h-7 w-7" />
        </div>
        <h1 className="text-xl font-black">Under Maintenance</h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          {settings?.system?.maintenance_message || "App is under maintenance. Please try later."}
        </p>
        <Link to="/auth" onClick={() => supabase.auth.signOut()} className="text-xs font-semibold text-primary underline">
          Sign out
        </Link>
      </div>
    );
  }

  return (
    <div className="mobile-shell flex min-h-screen flex-col">
      <div className="flex-1">
        <AppErrorBoundary scope="customer">
          <Outlet />
        </AppErrorBoundary>
      </div>
      <BottomNav />
    </div>
  );
}
